import React from 'react';
import Car, {VEHICLE_PLACEHOLDER_IMAGE} from '../../models/car.model';
import MessageModel from '../../models/message.model';
import {logger} from '../../services/utils.service';
import {expressInterestInCar, handleApiResponse, logJsError} from '../../services/api.service';
import {
    getFromStore,
    saveToStore,
    StorePath,
    storeSaveAction,
    useStoreActionsFromStore,
} from '../../services/store.service';
import {addLatestMessage} from '../../services/message.service';
import Carousel from '../common/Carousel';

const Cars = ({data}: { data: Car[] }) => {
    const storeAction = useStoreActionsFromStore(storeSaveAction);
    const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];

    const handleCarSelection = (car: Car) => {
        const typingTimeout = setTimeout(() => {
            saveToStore(storeAction, StorePath.AGENT_TYPING, true);
        }, 1300);
        logger('Selected car', car);
        expressInterestInCar(car.id)
            .then(handleApiResponse)
            .then((data: any) => {
                addLatestMessage(data.messages, messages, storeAction);
                saveToStore(storeAction, StorePath.AGENT_TYPING, false);
                clearTimeout(typingTimeout);
            })
            .catch((error) => {
                logJsError(error);
            });
    };

    const numberWithCommas = (number: number) => {
        return number.toLocaleString();
    };

    return (
        <Carousel gap={data.length > 1 ? 50 : 0} ariaLabel="Available cars">
            {data.map((car: Car) => (
                <div key={car.id} className="flex justify-center">
                    <div className="w-[220px] flex flex-row justify-center items-center mb-4">
                        <div className="border rounded-md flex flex-col my-3 items-center p-4">
                            <img src={car.images && car.images.length > 0 ? car.images[0] : VEHICLE_PLACEHOLDER_IMAGE} alt=""/>

                            <div className="flex flex-col items-center py-4">
                                <a href={car.link} target="_blank" className="text-center text-lg leading-none font-medium">
                                    {car.category} {car.year} {car.make} {car.model} {car.trim}
                                </a>
                                {typeof car.price === 'number' && (
                                    <div className="text-gray-500 font-light mt-[6px]">${numberWithCommas(car.price)}</div>
                                )}
                            </div>

                            <button className="border border-primary bg-primary rounded-full text-white font-bold mt-[20px] py-2 px-4 hover:bg-white hover:text-primary"
                                    onClick={() => handleCarSelection(car)}>
                                Tell me more
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
    );
};

export default Cars;
